import dynamic from "next/dynamic";

export let icons = {
        'arrow-diagonal': dynamic(() => import('../icons/arrow-diagonal.svg')),
        'arrow-down': dynamic(() => import('../icons/arrow-down.svg')),
        'arrow-left': dynamic(() => import('../icons/arrow-left.svg')),
        'arrow-level-down': dynamic(() => import('../icons/arrow-level-down.svg')),
        'arrow-right': dynamic(() => import('../icons/arrow-right.svg')),
        'arrow-up': dynamic(() => import('../icons/arrow-up.svg')),
        'camera': dynamic(() => import('../icons/camera.svg')),
        'card-logo': dynamic(() => import('../icons/card-logo.svg')),
        'cc-off': dynamic(() => import('../icons/cc-off.svg')),
        'cc-on': dynamic(() => import('../icons/cc-on.svg')),
        'check': dynamic(() => import('../icons/check.svg')),
        'chevron': dynamic(() => import('../icons/chevron.svg')),
        'close': dynamic(() => import('../icons/close.svg')),
        'envelope': dynamic(() => import('../icons/envelope.svg')),
        'expanding-arrow-diagonal': dynamic(() => import('../icons/expanding-arrow-diagonal.svg')),
        'expanding-arrow-left': dynamic(() => import('../icons/expanding-arrow-left.svg')),
        'expanding-arrow-right': dynamic(() => import('../icons/expanding-arrow-right.svg')),
        'facebook-square': dynamic(() => import('../icons/facebook-square.svg')),
        'facebook': dynamic(() => import('../icons/facebook.svg')),
        'filter': dynamic(() => import('../icons/filter.svg')),
        'globe': dynamic(() => import('../icons/globe.svg')),
        'great-wall-grid': dynamic(() => import('../icons/great-wall-grid.svg')),
        'great-wall-scroller': dynamic(() => import('../icons/great-wall-scroller.svg')),
        'headphone-off': dynamic(() => import('../icons/headphone-off.svg')),
        'headphone': dynamic(() => import('../icons/headphone.svg')),
        'instagram': dynamic(() => import('../icons/instagram.svg')),
        'line-diagonal': dynamic(() => import('../icons/line-diagonal.svg')),
        'line': dynamic(() => import('../icons/line.svg')),
        'link': dynamic(() => import('../icons/link.svg')),
        'linkedin': dynamic(() => import('../icons/linkedin.svg')),
        'loading': dynamic(() => import('../icons/loading.svg')),
        'location-pin': dynamic(() => import('../icons/location-pin.svg')),
        'lock': dynamic(() => import('../icons/lock.svg')),
        'logo-404': dynamic(() => import('../icons/logo-404.svg')),
        'logo-dynamic': dynamic(() => import('../icons/logo-dynamic.svg')),
        'logo-empowering': dynamic(() => import('../icons/logo-empowering.svg')),
        'logo-footer': dynamic(() => import('../icons/logo-footer.svg')),
        'logo-large': dynamic(() => import('../icons/logo-large.svg')),
        'logo-news': dynamic(() => import('../icons/logo-news.svg')),
        'logo-pristine': dynamic(() => import('../icons/logo-pristine.svg')),
        'logo-reverential': dynamic(() => import('../icons/logo-reverential.svg')),
        'logo-worded': dynamic(() => import('../icons/logo-worded.svg')),
        'logo': dynamic(() => import('../icons/logo.svg')),
        'maximize': dynamic(() => import('../icons/maximize.svg')),
        'microphone': dynamic(() => import('../icons/microphone.svg')),
        'minimize': dynamic(() => import('../icons/minimize.svg')),
        'minus': dynamic(() => import('../icons/minus.svg')),
        'pause': dynamic(() => import('../icons/pause.svg')),
        'pdf': dynamic(() => import('../icons/pdf.svg')),
        'phone': dynamic(() => import('../icons/phone.svg')),
        'play': dynamic(() => import('../icons/play.svg')),
        'plus': dynamic(() => import('../icons/plus.svg')),
        'print': dynamic(() => import('../icons/print.svg')),
        'reload': dynamic(() => import('../icons/reload.svg')),
        'search': dynamic(() => import('../icons/search.svg')),
        'share': dynamic(() => import('../icons/share.svg')),
        'sort': dynamic(() => import('../icons/sort.svg')),
        'threads': dynamic(() => import('../icons/threads.svg')),
        'tick': dynamic(() => import('../icons/tick.svg')),
        'twitter': dynamic(() => import('../icons/twitter.svg')),
        'union': dynamic(() => import('../icons/union.svg')),
        'user': dynamic(() => import('../icons/user.svg')),
        'volume': dynamic(() => import('../icons/volume.svg')),
        'youtube': dynamic(() => import('../icons/youtube.svg'))
    };
